import React, { Component } from 'react';
import { Button, DatePicker, Modal, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil';

const { MonthPicker } = DatePicker;

class Filter extends Component {
    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计月份',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        );
    }
}

class VisitNum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            searchParams: {},
            curParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            visible: false,
            businessList: [],
        }
    }

    componentDidMount() {
        this.queryEffectiveDate();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { trueMonth, trueYear, date: nowDate } = res;
            const { searchParams } = this.state;
            const date = `${trueYear}-${trueMonth < 10 ? `0${trueMonth}` : trueMonth}`;
            searchParams.date = date;
            const nowDay = moment(nowDate).format('DD');
            this.setState({
                searchParams,
                exportMaxTime: nowDay == 31 ? moment(nowDate).add(1,'M').format('YYYY-MM') : moment(nowDate).format('YYYY-MM'),
                exportTime: nowDay == 31 ? moment(nowDate).format('YYYY-MM') : moment(nowDate).add(-1,'M').format('YYYY-MM'),
                curParams: {...searchParams},
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvStandardVisitAmount,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.dashboard.exportInvStandardVisitAmount;
        this.addToDownloadSite({ ...sortParams, ...curParams }, url, 'Query_Inv_Standard_Visit_Amount');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId }
                const options = {
                    method: 'POST',
                    url,
                    data: params,
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                    },
                };
                $.sendRequest(options);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'dateShow',
            key: 'dateShow',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目经理工号',
            dataIndex: 'pmEmployeeCode',
            key: 'pmEmployeeCode',
            width: 90,
        }, {
            title: '项目经理姓名',
            dataIndex: 'pmUserCompellation',
            key: 'pmUserCompellation',
            width: 90,
        }, {
            title: '项目经理主管工号',
            dataIndex: 'pmLeaderEmployeeCode',
            key: 'pmLeaderEmployeeCode',
            width: 80,
        }, {
            title: '项目经理主管姓名',
            dataIndex: 'pmLeaderUserCompellation',
            key: 'pmLeaderUserCompellation',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 160,
        }, {
            title: '完成访视类型',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 120,
        }, {
            title: '完成访视数',
            dataIndex: 'visitAmount',
            key: 'visitAmount',
            width: 105,
        }, {
            title: '项目分类影响权重',
            dataIndex: 'investigationTypeWeight',
            key: 'investigationTypeWeight',
            width: 80,
        }, {
            title: '访视类型影响权重',
            dataIndex: 'visitTypeWeight',
            key: 'visitTypeWeight',
            width: 80,
        }, {
            title: '项目难度系数',
            dataIndex: 'difficultyDegreeTypeWeight',
            key: 'difficultyDegreeTypeWeight',
            width: 90,
        }, {
            title: '标准访视数',
            dataIndex: 'standardVisit',
            key: 'standardVisit',
            width: 80,
        }, {
            title: '人员在项目中角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
        }, {
            title: '人员姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: '人员工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: 'CRC项目FTE',
            dataIndex: 'crcFte',
            key: 'crcFte',
            width: 90,
        }, {
            title: '当月随机数',
            dataIndex: 'randomCount',
            key: 'randomCount',
            width: 90,
        }, {
            title: '工时确认状态',
            dataIndex: 'manHourStatus',
            key: 'manHourStatus',
            width: 90,
        }, {
            title: '访视数分配系数',
            dataIndex: 'distributionWeight',
            key: 'distributionWeight',
            width: 80,
        }, {
            title: '分配后确认标准访视数',
            dataIndex: 'distributionStandardVisit',
            key: 'distributionStandardVisit',
            width: 80,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    exportTimeChange = (date, datestr) => {
        this.setState({ exportTime: datestr })
    }

    onCancel = () => {
        const { exportMaxTime } = this.state;
        this.setState({ visible: false, exportTime: moment(exportMaxTime).add(-1,'M').format('YYYY-MM') })
    }

    exportSolidify = () => {
        const { exportTime } = this.state;
        if(!exportTime) {
            message.error('请选择导出固化月份！')
            return
        }
        ExportUtil.export({date: exportTime}, null, API_URL.dashboard.downloadInvStandardVisitAmount);
        message.success('正在下载中!');
        this.onCancel();
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, visible, exportTime, exportMaxTime, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>,
                            <Button key="exportSolidify" className="btn-yellow" style={{marginLeft: 8}} 
                            onClick={ () => this.setState({visible:true})}>导出固化数据</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="visitNum"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <Modal
                    title='导出固化数据'
                    visible={visible}
                    maskClosable={false}
                    width={350}
                    onOk={this.exportSolidify}
                    onCancel={this.onCancel}
                >
                    <div>
                        <label style={{marginRight: 20}}>请选择固化月份</label>
                        <MonthPicker
                            value={exportTime ? moment(exportTime) : undefined} 
                            placeholder="请选择" 
                            onChange={ this.exportTimeChange }
                            disabledDate={(current) => {
                                return current && current.valueOf() >= moment(exportMaxTime).valueOf() || 
                                current.valueOf() < moment('2024-09').valueOf() }}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default VisitNum;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/visitNum.js